module.exports = __webpack_public_path__ + "static/background-d892c535053b8033c80fe94d6d8e1687.svg";